/** Tab values are fixed, not positions: the persisted `rightTabs` of existing users keeps pointing at the same tab. */
export const RIGHT_TAB_RISK_FACTORS = 0;
export const RIGHT_TAB_PH_RECOMMENDATION = 1;
export const RIGHT_TAB_ALERTS = 2;
